import React from 'react';

import DeleteIcon from '@mui/icons-material/Delete';

export function CustomDeleteIcon({ onClick, enable }) {
  return (
    <DeleteIcon
      onClick={enable ? onClick : null}
      sx={{ cursor: 'pointer', color: enable ? 'red' : 'grey' }}
    />
  );
}
